const NON_SESSION_PREFIXES = ["new", "edit", "test"];
const HEADER_VISIBLE_SUFFIXES = [
  "feedback",
  "session-feedback",
  "insights",
  "participant",
];

export function isActiveSessionPage(pathname: string): boolean {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] !== "constellation" || segments.length < 3) {
    return false;
  }
  if (NON_SESSION_PREFIXES.includes(segments[1])) {
    return false;
  }
  return !HEADER_VISIBLE_SUFFIXES.includes(segments[2]);
}
